import React, { Fragment } from 'react'
import Sidebar from '../Components/Sidebar'
import Charts from '../Components/Dashboard/Charts'
import Filter from '../Components/Dashboard/Filter'
import DataBoxes from '../Components/Dashboard/DataBoxes'

function Dashboard() {
    return (
        <Fragment>
            <div class="container-fluid">
                <div className='row'>
                    <div className='col-sm-3 sidebarss'>
                        <Sidebar />
                    </div>
                    <div className='col-sm-9 ssidebar'>
                        <Filter />
                        <Charts />
                        <DataBoxes />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Dashboard